import { MutationTree } from 'vuex'
import { IShoppingCartState, IProductExtended } from '@/@types'
import CONSTANTS from '@/constants'

const { PLANS } = CONSTANTS

const mutations: MutationTree<IShoppingCartState> = {
  SHOPPING_CART_UPDATED: (state, shoppingCart: Array<IProductExtended>) => {
    state.shoppingCart = shoppingCart
  },
  SHOPPING_CART_REMOVED_ITEM_UPDATED: (state, product: IProductExtended) => {
    if (product.addOnChecked) {
      product.addOnChecked = false
    }
    state.shoppingCart = state.shoppingCart.filter(item => {
      // item is NOT PLANS.SKILL_DIVE_ANNUAL
      // go for regular filtering
      item.recurlyItem = false
      if (item.merchant_id !== PLANS.SKILL_DIVE_ANNUAL) {
        return item.merchant_id !== product.merchant_id
      }
      // item is PLANS.SKILL_DIVE_ANNUAL
      // check if there are *NO* Skill Dive AddOns checked to filter the plan
      if (item.merchant_id === PLANS.SKILL_DIVE_ANNUAL && item.addOnsOnCart?.length === 0) {
        item.recurlySDLACounter = item.addOnsOnCart?.length
        item.recurlySDItem = false
        return item.merchant_id !== product.merchant_id
      }
      // if there are Skill Dive AddOns checked do not filter the plan
      return true
    })
  },
  BUNDLE_PRODUCT_ERROR_UPDATED: (state, error: { type: string }) => {
    state.bundleProductHasError = error
  },
  SHOPPING_CART_SELECTED_PLAN_UPDATED: (state, selectedPlan: IProductExtended) => {
    state.selectedPlan = selectedPlan
  },
  ADD_ONS_CERTIFICATIONS_LIST_UPDATED: (
    state,
    addOnsCertificationsList: Array<IProductExtended>
  ) => {
    state.addOnsCertificationsList = addOnsCertificationsList
  },
  ADD_ADDONS_TO_PLAN_IN_CART: (
    state,
    { plan, addOn }: { plan: IProductExtended; addOn: IProductExtended }
  ) => {
    const planIndex = state.shoppingCart.findIndex(item => item.merchant_id === plan.merchant_id)
    if (planIndex !== -1) {
      const planItem = state.shoppingCart[planIndex]
      if (!planItem.addOnsOnCart) {
        planItem.addOnsOnCart = []
      }
      planItem.addOnsOnCart.push(addOn)
      state.shoppingCart.splice(planIndex, 1, planItem)
    }
  },
  REMOVE_ADDONS_TO_PLAN_IN_CART: (
    state,
    { plan, addOn }: { plan: IProductExtended; addOn: IProductExtended }
  ) => {
    const planIndex = state.shoppingCart.findIndex(item => item.merchant_id === plan.merchant_id)
    if (planIndex !== -1) {
      const planItem = state.shoppingCart[planIndex]
      if (planItem.addOnsOnCart) {
        planItem.addOnsOnCart = planItem.addOnsOnCart.filter(
          item => item.merchant_id !== addOn.merchant_id
        )
        state.shoppingCart.splice(planIndex, 1, planItem)
      }
    }
  },
  SET_SELECTED_ADDONS_BY_USER: (state, selectedAddOnsByUser: boolean) => {
    state.selectedAddOnsByUser = selectedAddOnsByUser
  },
}

export default mutations
